<template>
  <b-container fluid>
    <div class="mb-5">
      <div class="my-4">
        <h1>Convocations</h1>
      </div>
      <hr />
    </div>
  </b-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
